export const system = "Auth" as const;
